type DictionaryType = {
  [lang: string]: {
    [key: string]: string;
  }
}

const Dictionary: DictionaryType = {
  ja: {
    label : '日本語',
    site  : 'はやぶさ２拡張ミッション乗車券',

    // forms
    required              : '必須',
    name                  : 'お名前',
    name_placeholder      : '山田太郎',
    name_note             : '［必須］全角16文字・半角32文字まで使用できます。現在半角%d文字相当です。',
    country               : '国名',
    outgoing_message      : '探査機に搭載する言葉',
    outgoing_message_note : '全角32文字・半角64文字まで使用できます。探査機に搭載する言葉は公開されません。探査機に搭載する言葉に使用できる文字列に制限があります。"環境依存文字"は使わないでください。より詳しくは、文字コード"EUC-JP"に変換できる文字を使うことができます。現在半角%d文字相当です。',
    mission_message       : 'はやぶさ2拡張ミッションへのメッセージ',
    mission_message_note  : '全角128文字・半角256文字まで使用できます。現在半角%d文字相当です。',
    confirm_message_note  : 'ミッションへのメッセージがサイト内で公開されます。',

    confirm_publishing    : 'メッセージの公開を許可',
    none                  : 'なし',
    allow                 : '許可する',
    deny                  : '許可しない',

    message_editable      : 'メッセージの変更ができます。',

    // errors
    error_name_not_found            : '「お名前」は必須項目です。',
    error_name_too_long             : '「お名前」が長すぎます。',
    error_outgoing_message_too_long : '「探査機に搭載する言葉」が長すぎます。',
    error_outgoing_message_unusable_characters : '「探査機に搭載する言葉」に使用できない文字が含まれています。使用できない該当文字が"?"で表示されています。この箇所を(EUC-JPに変換可能な文字に)適宜修正して再度確認してください。',
    error_mission_message_too_long  : '「はやぶさ２拡張ミッションへのメッセージ」が長すぎます。',

    // buttons
    next     : '次へ',
    stamp    : 'スタンプ',
    confirm  : '確認',
    publish  : '発券',
    edit     : '編集',
    back     : '戻る',
    download : 'ダウンロードする',
    share    : '共有ページを開く',

    // view=undefined (menu)
    publish_ticket: '新規乗車券発行',
    publish_ticket_note: '乗車券を新規に発行します。',

    add_stamp: 'スタンプ追加',
    add_stamp_note: '乗車券へスタンプを追加します。<br/>発行済みの乗車券番号が必要です。',

    check_ticket: '乗車券確認',
    check_ticket_note: '乗車券を確認します。<br/>発行済みの乗車券番号が必要です。',

    // view=published
    published_main_title: '発券完了',
    published_main_note: `<p>必ずページの最後までご確認ください。</p>`,
    published_main_number: `
    <p>乗車券を発券しました。</p>
    <p>乗車券番号は</p>
    <div style="padding: 10px; margin: 10px; font-size: large; font-weight: bold; background: black; border: 1px solid white; border-radius: 5px;">%s-%s</div>
    <p>です。</p>
    `,
    published_main_caution: `
    <em>氏名</em>と<em>乗車券番号</em>は今後も使用します。また再発行ができません。<br/>
    <strong>紛失したり、他の人に教えたりしないよう、十分注意して管理してください。</strong>
    `,
    published_download_title: 'ダウンロード',
    published_download_note: '乗車券は PDF でダウンロードできます。',

    published_share_title: 'SNS などに投稿する',
    published_share_note: '下記の共有用ページをご活用ください。<br/>（別ウィンドウで開きます）',
    published_share_caution: `
    SNS などに投稿する場合は、 <strong>乗車券番号等重要な情報を伏せる必要があります</strong>。<br/>
    ダウンロードした PDF などを使用される場合は、十分注意してください。
    `,

    // view=addition
    ticket_id: '乗車券番号',
    ticket_id_note: '[必須] 乗車券番号は、発行された乗車券 PDF などに記載されています。',

    // messages.html
    messages_from_everyone: 'みんなのメッセージ',
  },
  en: {
    label  : 'English',
    site   : 'Hayabusa2 Extended Mission Boarding Pass',

    // forms
    required              : 'Required',
    name                  : 'Name',
    name_placeholder      : 'John Smith',
    name_note             : '[Required] Up to 32 alphabetical characters, including spaces. Characters used: %d. ',
    country               : 'Country',
    outgoing_message      : 'Message to be sent to the spacecraft',
    outgoing_message_note : 'Up to 64 alphabetical characters, including spaces. If you use characters other than the alphabet, you can only use the characters in the EUC-JP character code. Characters used: %d. ',
    mission_message       : 'Message for the Hayabusa2 Extended Mission',
    mission_message_note  : 'Up to 256 alphabetical characters, including spaces. Characters used: %d. ',
    confirm_message_note  : 'The message to the mission will be published on our website. ',

    confirm_publishing    : 'I agree to my message being published ',
    none                  : 'None selected',
    allow                 : 'Agree',
    deny                  : 'Deny',

    message_editable      : 'You can edit your message. ',

    // errors
    error_name_not_found            : ' "Name" is a required field. ',
    error_name_too_long             : ' Entered name is too long. ',
    error_outgoing_message_too_long : ' "Message to be sent to the spacecraft" is too long. ',
    error_outgoing_message_unusable_characters : ' "Message to be sent to the spacecraft" includes unsupported characters. Characters that cannot be used are displayed as "?". Please correct these parts and check again. ',
    error_mission_message_too_long  : ' "Message to the Hayabusa2 Extended Mission" is too long. ',

    // buttons
    next     : 'Next',
    stamp    : 'Stamp',
    confirm  : 'Confirm',
    publish  : 'Issue ticket',
    edit     : 'Edit',
    back     : 'Back',
    download : 'Download',
    share    : 'Share ticket',

    // view=undefined (menu)
    publish_ticket: 'New ticket',
    publish_ticket_note: 'Issue a new ticket.',

    add_stamp: 'Add another stamp',
    add_stamp_note: 'To add another stamp to the ticket.<br/>You will need the issued ticket number.',

    check_ticket: 'Check ticket',
    check_ticket_note: 'Check the ticket.<br/>You will need the issued ticket number.',

    // view=published
    published_main_title: 'Ticket complete',
    published_main_note: `<p>Please read to the end of the page. </p>`,
    published_main_number: `
    <p>Ticket issued.</p>
    <p>Your ticket number is</p>
    <div style="padding: 10px; margin: 10px; font-size: large; font-weight: bold; background: black; border: 1px solid white; border-radius: 5px;">%s-%s</div>
    <p>.</p>
    `,
    published_main_caution: `
    <em>Your name</em> and <em>ticket number</em> are now registered and cannot be reissued. <br/>
    <strong>Please take care not to lose your ticket number or share with another person. </strong>
    `,
    published_download_title: 'Download',
    published_download_note: 'Download ticket as PDF',

    published_share_title: 'Share on social media',
    published_share_note: 'Click below to create a sharable version of your ticket.<br/>（Opens in new window）',
    published_share_caution: `
    When posting on social media or similar, <strong>important information such as your ticket number must be hidden</strong>. <br/>
    Please be careful when using the downloaded PDF or similar that shows the ticket number.
    `,

    // view=addition
    ticket_id: 'Ticket ID',
    ticket_id_note: '[Required] The ticket ID can be found on the issued ticket PDF.',

    // messages.html
    messages_from_everyone: 'Messages from everyone',
  }
}

export default Dictionary
